(() => {
  function initializeStories(context) {
    const sections = context.matches?.('[data-stories]') ? [context] : context.querySelectorAll('[data-stories]');
    sections.forEach(section => {
      if (section.dataset.storiesEnhanced) return;
      const track = section.querySelector('[data-stories-track]');
      const controls = section.querySelector('[data-stories-controls]');
      const previous = section.querySelector('[data-stories-prev]');
      const next = section.querySelector('[data-stories-next]');
      const cards = section.querySelectorAll('.bs-stories__item');
      if (!track || !controls || !previous || !next || !cards.length || typeof track.scrollBy !== 'function') return;
      section.dataset.storiesEnhanced = 'true';

      const maximum = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const behavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      const update = () => {
        const end = maximum();
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= end - 1;
        controls.hidden = end <= 1;
      };
      const step = direction => {
        const distance = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].getBoundingClientRect().width;
        track.scrollBy({ left: direction * distance, behavior: behavior() });
      };

      previous.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          step(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          track.scrollTo({ left: event.key === 'Home' ? 0 : maximum(), behavior: behavior() });
        }
      });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(track);
      } else {
        window.addEventListener('resize', update, { passive: true });
      }
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeStories(document), { once: true });
  } else {
    initializeStories(document);
  }
  document.addEventListener('shopify:section:load', event => initializeStories(event.target));
})();
